import type { SVGProps } from "react";

export function IconWhiteStorefront(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M26 57V48C26 44.6863 28.6863 42 32 42C35.3137 42 38 44.6863 38 48V57M7 17.5H57M7 24.335C7 26.5455 7.87815 28.6656 9.44126 30.2287C11.0044 31.7918 13.1244 32.67 15.335 32.67C17.5456 32.67 19.6656 31.7918 21.2287 30.2287C22.7919 28.6656 23.67 26.5455 23.67 24.335C23.67 26.5455 24.5481 28.6656 26.1112 30.2287C27.6743 31.7918 29.7943 32.67 32.0049 32.67C34.2155 32.67 36.3355 31.7918 37.8987 30.2287C39.4618 28.6656 40.3399 26.5455 40.3399 24.335C40.3399 26.5455 41.2182 28.6656 42.7814 30.2287C44.3445 31.7918 46.4645 32.67 48.6751 32.67C50.8857 32.67 53.0057 31.7918 54.5688 30.2287C56.1319 28.6656 57.0101 26.5455 57.0101 24.335M7 7H57V57H7V7Z"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
